import html2canvas from 'html2canvas'
import wayniLogo from '../assets/images/waynimovil.png'
// this function fixes all the rendering problems
// that the transfer proof gets when transformed
// in an image


export const generateProof = async (element) => {
  // clone the node
  const elementCopy = element.cloneNode(true)

  const parentProof = document.createElement('div')
  parentProof.appendChild(elementCopy)
  parentProof.style.width = '420px'
  parentProof.style.padding = '2rem 1rem'

  // add logo
  const logo = document.createElement('img')
  logo.src = wayniLogo
  logo.style.width = '171px'
  logo.style.margin = '0 auto'
  elementCopy.insertBefore(logo, elementCopy.firstChild)

  // work on style fixes
  const firstCard = elementCopy.querySelector('#proof-data')
  firstCard.style.borderRadius = '8px'
  firstCard.style.border = '1px #D1D1D7 solid'

  const secondCard = elementCopy.querySelector('#list')
  secondCard.style.borderRadius = '8px'
  secondCard.style.border = '1px #D1D1D7 solid'

  const badge = firstCard.querySelector('#status-badge')
  badge.style.marginTop = '1rem'
  badge.style.position = 'relative'
  badge.style.width = '168px'
  badge.style.height = '26px'
  badge.style.display = 'flex'
  badge.style.alignItems = 'center'
  
  const tickIcon = elementCopy.querySelector('#tick-icon')
  tickIcon.style.paddingTop = '1px'

  const statusText = firstCard.querySelector('#status-text')
  statusText.style.paddingTop = '-10px'
  statusText.style.position = 'absolute'
  statusText.style.left = '30px'
  statusText.style.bottom = '10px'
  statusText.style.height = '18px'

  // append it to body so html2canvas lib can transform it
  document.body.appendChild(parentProof)

  // export and download
  exportAsImage(parentProof, 'Comprobante de transferencia')

  // remove from body
  document.body.removeChild(parentProof)
}

export const exportAsImage = async (element, imageFileName) => {
  const canvas = await html2canvas(element, {
    allowTaint: true,
    useCORS: true,
    logging: true
  })
  const imageURL = canvas.toDataURL('image/png', 1.0)
  downloadImage(imageURL, imageFileName)
}

const downloadImage = (blob, fileName) => {
  const fakeLink = window.document.createElement('a')
  fakeLink.style.display = 'none'
  fakeLink.download = fileName

  fakeLink.href = blob

  document.body.appendChild(fakeLink)

  fakeLink.click()

  document.body.removeChild(fakeLink)

  fakeLink.remove()
}
